<template>
  <div>
    <h1 class="my-4">
      {{ $t('pages.reset-password.title') }}
    </h1>
    <b-card
      class="mx-auto text-left p-5"
      style="width: 80%;"
    >
      <div
        v-if="tokenLength && !passwordChanged"
        class="row"
      >
        <div
          class="col-12 col-md-3"
          style="font-size: 0.9rem;"
        >
          {{ $t('pages.reset-password.instructions') }}
        </div>
        <div class="col-12 col-md-8">
          <form>
            <b-form-group
              id="fieldset-email"
              :label="$t('inputs.email.title')"
              label-for="email"
              :invalid-feedback="$t('inputs.email.validation')"
              :state="emailState"
            >
              <b-form-input
                id="email"
                v-model="data.email"
                size="sm"
                :placeholder="$t('inputs.email.placeholder')"
              />
            </b-form-group>
            <b-form-group
              id="fieldset-email"
              :label="$t('pages.reset-password.new-password')"
              label-for="email"
              :invalid-feedback="$t('inputs.password.validation')"
              :state="passwordState"
            >
              <b-form-input
                id="password"
                v-model="data.password"
                type="password"
                size="sm"
                :placeholder="$t('inputs.password.placeholder')"
              />
            </b-form-group>
            <b-form-group
              id="fieldset-email"
              :label="$t('pages.reset-password.repeat-new-password')"
              label-for="password_confirm"
              :invalid-feedback="$t('inputs.password-confirm.title')"
              :state="passwordConfirmState"
            >
              <b-form-input
                id="password_confirm"
                v-model="data.password_confirmation"
                type="password"
                size="sm"
                :placeholder="$t('inputs.password-confirm.placeholder')"
              />
            </b-form-group>
            <b-button
              variant="success"
              size="sm"
              @click="submit"
            >
              {{ $t('pages.reset-password.change-password') }}
            </b-button>
          </form>
        </div>
      </div>
      <div v-if="!tokenLength && !passwordChanged">
        <p>
          {{ $t('pages.reset-password.oops') }}
        </p>
        <p>
          {{ $t('pages.reset-password.if-error') }}
        </p>
      </div>
      <div v-if="tokenLength && passwordChanged && !resetPasswordError">
        {{ $t('pages.reset-password.success-msg') }}
        <div class="mt-2">
          <b-button
            variant="success"
            size="sm"
            @click="$router.push({ name: 'Login' })"
          >
            <span style="text-transform: uppercase;">{{ $t('generic.login') }}</span>
          </b-button>
        </div>
      </div>
      <div v-if="tokenLength && passwordChanged && resetPasswordError">
        {{ $t('pages.reset-password.error-msg') }}
        <div class="mt-2">
          <b-button
            variant="success"
            size="sm"
            @click="$router.push({ name: 'home' })"
          >
            <span style="text-transform: uppercase;">{{ $t('generic.home') }}</span>
          </b-button>
          <b-button
            variant="success"
            size="sm"
            class="ml-1"
            @click="$router.push({ name: 'ForgotPassword' })"
          >
            {{ $t('pages.reset-password.request-link') }}
          </b-button>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {
        token: "",
        email: "",
        password: "",
        password_confirmation: ""
      },
      loginStart: true,
      passwordChanged: false,
      resetPasswordError: false,
    }
  },
  computed: {
    tokenLength() {
      return this.data.token.length === 64;
    },
    emailState() {
      /*eslint-disable */
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      /*eslint-enable */
      return (
        re.test(String(this.data.email).toLowerCase()) || this.loginStart
      );
    },
    passwordState() {
      return this.data.password.length >= 6 || this.loginStart;
    },
    passwordConfirmState() {
      return this.data.password.length >= 6 || this.loginStart;
    },
    readyToSend() {
      return this.emailState && this.passwordState && this.passwordConfirmState && this.tokenLength;
    }
  },
  mounted() {
    this.data.token = this.$route.query.token;
  },
  methods: {
    submit() {
      this.loginStart = false;

      if (this.readyToSend) {
        this.axios.post('/auth/password/reset', this.data)
        .then(() => {
            this.passwordChanged = true;
        })
        .catch(() => {
          this.passwordChanged = true;
          this.resetPasswordError = true;
        });
      }
    }
  }
}
</script>
